// import * as THREE from 'three';
export enum LocalStorageKey {
  JWT = 'JWT',
}

export enum PatchesName {
  Home = 'home',
  Login = 'login',
  User = 'user',
  Profile = 'profile',
}
export enum StepsEnum {
  Step_1,
  Step_2,
  Step_3,
  Step_4,
  Step_5,
}
